import { render, staticRenderFns } from "./VirtualFolderForm.vue?vue&type=template&id=40001c16&scoped=true&"
import script from "./VirtualFolderForm.vue?vue&type=script&lang=js&"
export * from "./VirtualFolderForm.vue?vue&type=script&lang=js&"
import style0 from "./VirtualFolderForm.vue?vue&type=style&index=0&id=40001c16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40001c16",
  null
  
)

export default component.exports